import { render } from "./CommonHeader.vue?vue&type=template&id=a7923614&scoped=true"
const script = {}

import "./CommonHeader.vue?vue&type=style&index=0&id=a7923614&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7923614"]])

export default __exports__